import en from './en';
import fr from './fr';
import ar from './ar';
import frCA from './fr_CA';
import zhCN from './zh_CN';
import zhTW from './zh_TW';
import de from './de';
import es from './es';
import it from './it';
import ja from './ja';
import ko from './ko';
import nl from './nl';
import pl from './pl';
import pt from './pt';
import ru from './ru';
import th from './th';
import tr from './tr';

const baseMessages: Record<string, Record<string, string>> = {
  en,
  fr,
  ar,
  frCA,
  zhCN,
  de,
  es,
  it,
  ja,
  ko,
  nl,
  pl,
  pt,
  ru,
  th,
  tr,
  zhTW,
};

const messagesClient = new Proxy(baseMessages, {
  get: (target, locale: string) => {
    if (locale in target) {
      return target[locale];
    }

    const fallbackMap: Record<string, string> = {
      en: 'en',
      'en-*': 'en',
      'fr-*': 'fr',
      'zh-*': 'zhCN',
      'fr-CA': 'frCA',
    };

    const matchedPattern = Object.keys(fallbackMap).find((pattern) => {
      if (pattern.endsWith('-*')) {
        return locale.startsWith(pattern.slice(0, -2));
      }

      return locale === pattern;
    });

    const fallbackLocale = matchedPattern ? fallbackMap[matchedPattern] : 'en';

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return target[fallbackLocale] ?? target.en;
  },
});

export default messagesClient;
